import A from 'components/atoms/A/A';
import { CONTACT_US, PARTNERS } from '../pages';
import Heading from 'components/atoms/Heading/Heading';

export const enTermsConditions = (
  <>
    <section>
      <Heading level={1}>Terms and conditions</Heading>
      <p>
        This page (together with the policies and other terms it refers to) tells you the terms and
        conditions on which we supply our service <strong>(&quot;our service&quot;)</strong>{' '}
        including our website www.qmee.com <strong>(&quot;our site&quot;)</strong> and the Qmee
        browser and mobile applications <strong>(&quot;our software&quot;)</strong> to you, whether
        as a guest or a registered user. Please read these terms and conditions carefully and make
        sure that you understand them before using this site, our services or our software. You
        should print a copy of these terms and conditions for future reference. These terms tell you
        who we are, how we will provide services to you, how you and we may change or end your use
        of the service, what to do if there is a problem and other important information.
      </p>
      <p>If you do not agree to these terms of use, please refrain from using our site.</p>
      <h2>Update to site and terms</h2>
      <p>
        We reserve the right to update or change these terms at any time by amending this page. We
        will provide notice of changes to the terms by posting the new terms on the site with a new
        effective date. You are expected to check this page from time to time to take notice of any
        changes we may make. We may update our site and software from time to time, and may change
        the content at any time. If the need arises, we may suspend access to our site or software,
        or close them indefinitely. Any of the material on our site may be out of date at any given
        time, and we are under no obligation to update such material. We do not guarantee that our
        site, or any content on it, will be free from errors or omissions.
      </p>
    </section>

    <section>
      <h2>Information about us</h2>
      <p>
        www.qmee.com (“Qmee”) is a site operated by Kantar UK Ltd <strong>(&quot;we&quot;)</strong>.
        We are registered in England and Wales under company number 03073845 and have our registered
        office at Tns House, Westgate, London, W5 1UA, UK.
      </p>
    </section>

    <section>
      <h2>How to contact us</h2>
      <p>
        You can contact us by using the <A href={CONTACT_US.path}>Contact us</A> link on our site,
        or by sending us an email at <A href="mailto:support@qmee.com">support@qmee.com</A>.
      </p>
    </section>

    <section>
      <h2>How we may contact you</h2>
      <p>
        If we have to contact you we will do so by writing to you at the email address you provided
        to us on registration.
      </p>
    </section>

    <section>
      <h2>Service availability</h2>
      <p>
        Our service is only intended for use by people resident in either the United Kingdom, the
        United States, Canada, Australia, France or Germany and accessing it from those countries.
        You should not use our service if you are resident in another country. We do not represent
        that content available on or through our site is appropriate or available in other
        locations. We may limit the availability of our site or our service or software to any
        person or geographic area at any time. If you choose to access our site from outside the
        United Kingdom, the United States, Canada, Australia, France or Germany , you do so at your
        own risk.
      </p>
    </section>

    <section>
      <h2>Your status</h2>
      <p>
        By downloading our software, you confirm that you are legally resident in either the United
        Kingdom, United States, Canada, Australia, France or Germany , that you are accessing our
        site from that country and that you are at least sixteen (16) years of age. You may only
        have one user account. Earnings made on any additional user accounts will not necessarily be
        paid and we have the right to disable any additional user accounts at any time.
      </p>
    </section>

    <section>
      <h2>Qmee services</h2>
      <h3>Sponsored results</h3>
      <p>
        The service we make available through our software operates by providing sponsored results
        when you carry out searches on certain third party search engines, based on your
        key-strokes. The sponsored results will be displayed in a separate window and are separate
        from any sponsored results displayed on the search engine&apos;s results pages. Subject to
        your compliance with these terms and conditions, when you click on a sponsored result in the
        Qmee window we may, in accordance with our user payment policy (as amended from time to
        time), credit a small sum of money (&quot;a payment&quot;) to the user account you have
        registered with us.
      </p>
      <h3>Cash rewards for surveys</h3>
      <p>
        From time to time we may offer cash rewards to users who complete surveys. Subject to your
        compliance with these terms and conditions, when you complete a survey we may, in accordance
        with our user payment policy (as amended from time to time), credit a reward into your Qmee
        account. Rewards will only be credited for surveys that are fully completed. There may be
        additional limitations on certain surveys or rewards so please carefully read all applicable
        terms and conditions before deciding whether or not to participate in the survey. The
        contents of the surveys are provided by third parties and such surveys should not be
        interpreted as endorsement by us of those third parties. We make no warranties or
        representations about and assume no responsibility for the content of the third party
        surveys.
      </p>
      <p>
        Any information which you submit as part of a survey (including but not limited to your year
        of birth, postcode or ZIP code, gender and survey responses) will be shared with the
        relevant <A href={PARTNERS.path}>survey partner</A>, Survey information may also be
        aggregated and shared with other third parties. Please see our privacy notice for further
        details.
      </p>
      <h3>Cash rewards for offers</h3>
      <p>
        From time to time we may offer cash rewards to users who complete a third-party offer.
        Subject to your compliance with these terms and conditions, and the terms and conditions
        shown on each individual offer, when you complete an offer we may, in accordance with our
        user payment policy (as amended from time to time), credit a reward into your Qmee account.
        Rewards will only be credited for offers that are advertised by Qmee and fully completed. We
        cannot be held responsible if the merchant fails to report a user&apos;s sale to us.
        Merchants have their own rules upon which they determine transactions to be genuine - for
        example, an attempt to simply earn a cash reward by clicking/registering with no intention
        to continue to use/buy from the merchant&apos;s website could be deemed as non-genuine.
        These rules may or may not be advertised by Qmee or the merchant and may be discretionary.
      </p>
      <h3>Extra incentivised activity</h3>
      <p>
        From time to time we may offer extra rewards for completing certain activities within your
        Qmee account (e.g. survey streaks).
      </p>
      <p>
        We reserve the right to limit, suspend or withdraw the extra rewards at any time, or to
        change the rewards offered.
      </p>
      <h3>Deal finder service</h3>
      <p>
        From time to time we may notify you through our software if we believe that a product you
        have searched for online is available for a lower price on a different site. We will make
        reasonable efforts to ensure that the price offered is up to date and accurate but the
        prices displayed will be provided to us by those third parties and so we do not guarantee
        that we will offer you the cheapest available price for the product or that the price is
        reliable, accurate or up to date. Similarly, while we aim to notify you of a price which is
        cheaper than the price which you are viewing, we do not guarantee that this will always be
        the case.
      </p>
      <p>
        Please note that the products offered are provided by third parties and all purchases made
        will be via third party sites. Your contract for those products will be with those third
        parties and on their relevant terms and conditions and notification of the price difference
        should not be interpreted as endorsement by us of those third parties. We make no warranties
        or representations about and assume no responsibility for the content of the third party
        sites and we have no liability to you in respect of such purchases.
      </p>
    </section>

    <section>
      <h2>How we may use your personal information</h2>
      <p>
        On creating your user account you will be asked to supply your e-mail address and country of
        residence. We will also store details of the searches you make when using the service. When
        you make a request to cash out the balance in your user account we may provide you with the
        option to submit further information, for instance your age or town of residence.
      </p>
      <p>
        More information about how we collect and process your data is available in our privacy
        policy.
      </p>
    </section>

    <section>
      <h2>Receiving payments</h2>
      <p>
        You will only be able to receive payments credited to your user account via PayPal or via
        such other payment provider that we make available from time to time. Alternatively, you can
        donate them to one of several charities from a list specified by us, or cash out to a
        giftcard from a list specified by us. To order a gift card you will need to verify your
        identity. We will let you know how we require you to do this; we might require you to first
        cash out (any amount) to your PayPal account or we might require you to go through an
        alternative identity checking service. If you choose to cash out to a giftcard you will be
        issued a code to redeem your giftcard. We do not hold any responsibility for the code issued
        and we will not be able to reissue the code. We reserve the right to remove any giftcards
        offered at any given time. You will be able to redeem your user account balance at any time,
        however some giftcards may have a minimum redemption threshold (for example, £5/$5). Please
        see the specific information provided about each giftcard during the redemption process for
        details of any minimum redemption thresholds. Options for redeeming your user account
        balance are subject to change on reasonable notice by us. We will not be liable for any
        payments owed to you in the event that you provide us with an incorrect PayPal account
        number or other relevant details. We will also not be liable for any payments owed to you in
        the event of a catastrophic data, software or server error, cyber-attack or other event that
        makes it impossible for us to determine the payments that have been accrued.
      </p>
      <p>
        We are entitled to suspend your user account at any time at our sole discretion. If your
        account has not been used for one (1) year or more we will retain the balance in the
        account, otherwise we will pay the balance of the account to you. We may also suspend your
        use of our service at any time at our sole discretion.
      </p>
      <p>
        You acknowledge and agree that we do not have the ability to determine whether or not the
        cash rewards you earned or redeemed through your Qmee account are considered reportable
        taxable earnings in your jurisdiction. You are therefore responsible for any and all tax
        liability arising from, or associated with, your use of the Qmee website and Qmee app,
        including liability arising from your accrual of cash rewards or your redemption of such
        cash rewards. As a condition of your continued use of the Qmee website and app, we reserve
        the right to require you to provide necessary tax reporting information if our records show
        that you are, or may be, required to report the value of cash rewards to an appropriate tax
        authority. You will find your full cash rewards history is available to you on your Qmee
        account History tab on your dashboard. We encourage you, as it is your responsibility, to
        seek advice of a tax expert in order to determine the tax consequences of your use of the
        Qmee website and app, and any associated cash rewards earned or redeemed.
      </p>
      <p>
        Qmee utilizes Hyperwallet payment services to deliver payments to you. Such payment services
        are subject to the{' '}
        <A href="https://pay.hyperwallet.com/hw2web/consumer/page/legalAgreement.xhtml">
          Hyperwallet Terms of Service
        </A>{' '}
        and the{' '}
        <A href="https://pay.hyperwallet.com/hw2web/consumer/page/legalAgreement.xhtml">
          Hyperwallet Privacy Policy
        </A>
        .
      </p>
    </section>

    <section>
      <h2>Friend get friend referral scheme</h2>
      <p>
        From time to time, we may offer a friend get friend referral scheme, to users designated by
        us. For every referral that signs up to Qmee through your referral link, you will receive a
        reward into your Qmee account, on their first cashout to PayPal or Gift card. Referrals must
        follow your referral link in order for you to receive the reward.
      </p>
      <p>We reserve the right to suspend the referral scheme at any time.</p>
    </section>

    <section>
      <h2>Accessing our service</h2>
      <p>
        Access to our service is permitted on a temporary basis, and we reserve the right to
        withdraw or amend the service we provide without notice (see below). We will not be liable
        if for any reason our service is unavailable at any time or for any period.
      </p>
      <p>
        From time to time, we may restrict access to some parts of our site, or our entire site, to
        users who have registered with us.
      </p>
      <p>
        You must not allow any other person to use your user account. You must treat your user
        account ID and password as confidential, and you must not disclose it to any third party. We
        have the right to disable any user account ID or password, whether chosen by you or
        allocated by us, at any time, if in our opinion you have failed to comply with any of the
        provisions of these terms and conditions.
      </p>
    </section>

    <section>
      <h2>Intellectual property rights</h2>
      <p>
        We are the owner or the licensee of all intellectual property rights in our service,
        including our site and our software. Those works are protected by copyright laws and
        treaties around the world. All such rights are reserved. None of this material may be
        reproduced or redistributed without our written permission. You may, however, download or
        print a single copy of any on-screen information for your own private use.
      </p>
      <p>
        If you print off, copy or download any part of our service in breach of these terms and
        conditions, your right to use our service will cease immediately and you must, at our
        option, return or destroy any copies of the materials you have made.
      </p>
      <p>Qmee is a EU and US registered trade mark of Kantar UK Ltd.</p>
    </section>

    <section>
      <h2>Our liability</h2>
      <p>
        If we fail to comply with these terms, we are responsible for loss or damage you suffer that
        is a foreseeable result of our breaking this contract or our failing to use reasonable care
        and skill, but we are not responsible for any loss or damage that is not foreseeable. Loss
        or damage is foreseeable if either it is obvious that it will happen or if, at the time the
        contract was made, both we and you knew it might happen.
      </p>
      <p>
        We are not liable or responsible for any failure to provide our service or failure to
        perform, or delay in performance of, any of our obligations under these terms and conditions
        that is caused by reasons outside our reasonable control.
      </p>
      <p>
        We are not liable for business losses. We only supply the service and software for domestic
        and private use. If you use the service or software for any commercial, business or re-sale
        purpose we will have no liability to you for any loss of profit, loss of business, business
        interruption, or loss of business opportunity.
      </p>
      <p>
        Nothing in these terms shall limit our liability for death or personal injury arising from
        our negligence, nor our liability for fraudulent misrepresentation or misrepresentation as
        to a fundamental matter, nor any other liability which cannot be excluded or limited under
        applicable law.
      </p>
      <p>
        When providing our service we provide links to the websites of third parties. We assume no
        responsibility for the content of the third party websites that are linked to. Such links
        should not be interpreted as endorsement by us of those linked websites. We will not be
        liable for any loss or damage that may arise from your use of them.
      </p>
    </section>

    <section>
      <h2>Misuse of account</h2>
      <p>
        Our service is intended to reward normal internet browsing behaviours and you should not
        click on a sponsored result if you have no genuine interest in that sponsored result or
        complete surveys inaccurately. If we are of the opinion (or our algorithms suggest) that you
        are abusing our service, including but not limited to clicking on sponsored results in which
        you have no genuine interest, clicking on a sponsored result on multiple occasions or
        completing surveys using inaccurate or fraudulent information, we are entitled, at our sole
        discretion, to reduce the amount of the payments being made to you or to stop making
        payments to you altogether.
      </p>
      <p>
        You must not misuse our service by knowingly introducing viruses, trojans, worms, logic
        bombs or other material which is malicious or technologically harmful.
      </p>
      <p>
        You must not attempt to gain unauthorised access to our service (including our site), the
        server on which our site is stored or any server, computer or database connected to our
        service. You must not attack our service via a denial-of-service attack or a distributed
        denial-of-service attack.
      </p>
      <p>
        By breaching this provision, you may commit a criminal offence under the Computer Misuse Act
        1990. We will report any such breach to the relevant law enforcement authorities and we will
        co-operate with those authorities by disclosing your identity to them. In the event of such
        a breach, your right to use our service (including our site) will cease immediately.
      </p>
    </section>

    <section>
      <h2>Reliance on information posted</h2>
      <p>
        Commentary and other materials posted on our site or otherwise provided by our service are
        not intended to amount to advice on which reliance should be placed. We therefore disclaim
        all liability and responsibility arising from any reliance placed on such materials by you
        or anyone who may be informed of any of such material.
      </p>
    </section>

    <section>
      <h2>Jurisdiction and applicable law</h2>
      <p>
        The English courts will have exclusive jurisdiction over any claim arising from, or related
        to, a visit to our site or use of our service although we retain the right to bring
        proceedings against you for breach of these conditions in your country of residence or any
        other relevant country.
      </p>
      <p>
        These terms of use and any dispute or claim arising out of or in connection with them or
        their subject matter or formation (including non-contractual disputes or claims) shall be
        governed by and construed in accordance with the law of England and Wales. However, if you
        are a resident of Northern Ireland you may also bring proceedings in Northern Ireland, and
        if you are resident of Scotland, you may also bring proceedings in Scotland.
      </p>
      <p>
        If you reside in the United States, this agreement will be governed by and construed in
        accordance with the laws of the State of New York without giving effect to any principles of
        conflict of law. You agree to first bring any case relating to a dispute hereunder to be
        decided before one arbitrator in final, binding, non-appealable arbitration in New York, NY
        under the rules of the American Arbitration Association. Each party shall divide the costs
        equally of such arbitration and in the event the arbitrator decides the arbitration fees
        would be hardship on you, the arbitrator may allow for Qmee to pay 100% of the arbitration
        fees (not including your attorneys’ fees, which must be borne by you). You may also
        participate in the arbitration by phone if you are unable to come to New York. You agree to
        bring any case hereunder individually and not as a member of any class or part of any type
        of class action case. YOU UNDERSTAND THAT EXCEPT FOR THE OBLIGATIONS SET OUT IN THIS
        SECTION, YOU WOULD HAVE A RIGHT TO A TRIAL BY JURY AND YOU HEREBY WAIVE SUCH RIGHT. An
        arbitration award hereunder may be enforced by any court of competent jurisdiction.
        Notwithstanding anything to the contrary herein, you agree that Qmee may bring an action
        relating to its intellectual property rights, including an injunction related to such
        rights, in any court of competent jurisdiction without using the arbitration mechanism
        herein. You acknowledge and agree that the warranty disclaimers and liability and remedy
        limitations in this Agreement are material terms of this Agreement and that they have been
        taken into account in the decision by Qmee to provide the service. You may not assign any of
        your rights, obligations or privileges without the prior, written consent of Qmee. This
        agreement and any Qmee posted operating rules constitute the entire agreement of the parties
        with respect to the subject matter of this agreement, and supersede all prior or
        contemporaneous communications and proposals whether oral, or written, between the parties
        with respect to the subject matter of this agreement, and supersede all prior or
        contemporaneous communications and proposals, whether oral or written, between the parties
        with respect to such subject matter.
      </p>
    </section>

    <section>
      <h2>Alternative Dispute Resolution</h2>
      <p>
        Alternative dispute resolution is a process where an independent body considers the facts of
        a dispute and seeks to resolve it, without you having to go to court. If you are not happy
        with how we have handled any complaint, disputes may be submitted for online resolution to
        the European Commission Online Dispute Resolution platform at the following address:{' '}
        <A href="https://ec.europa.eu/consumers/odr/">https://ec.europa.eu/consumers/odr/</A>.
      </p>
    </section>

    <section>
      <h2>Your concerns</h2>
      <p>
        If you have any questions or complaints about our site, our services, our software or your
        user account, please contact <A href="mailto:support@qmee.com">support@qmee.com</A>. Our
        service displays some content that belongs to and is made available by third parties
        (sponsored search messages, surveys). This content is the sole responsibility of the
        relevant party. We may review content for legality and compliance with our policies, and we
        may remove or refuse to display content that we reasonably believe is non-compliant. However
        we may not review content as a matter of course, so please do not assume that we do. If you
        have any concerns about any of the content displayed as part of our service, please contact{' '}
        <A href="mailto:support@qmee.com">support@qmee.com</A>.
      </p>
      <p>Thank you for visiting our site.</p>
      <p>
        <em>Last updated: February 2026</em>
      </p>
    </section>
  </>
);

export const frTermsConditions = (
  <>
    <section>
      <h1>Conditions générales</h1>
      <p>
        Cette page (ainsi que les politiques et autres conditions auxquelles elle fait référence)
        contient les conditions générales sur lesquelles nous nous appuyons pour vous fournir notre
        service <strong>(&laquo;&nbsp;notre&nbsp;service&nbsp;&raquo;)</strong>, notamment notre
        site Web www.qmee.com <strong>(&laquo;&nbsp;notre&nbsp;site&nbsp;&raquo;)</strong>, ainsi
        que le navigateur et les applications mobiles Qmee{' '}
        <strong>(&laquo;&nbsp;notre&nbsp;logiciel&nbsp;&raquo;)</strong>, que vous soyez un invité
        ou un utilisateur inscrit. Veuillez lire attentivement les présentes conditions générales et
        vous assurer de les comprendre avant d&apos;utiliser ce site, nos services ou notre
        logiciel. Nous vous suggérons d&apos;imprimer une copie des présentes conditions générales
        afin de pouvoir vous y référer ultérieurement. Ces conditions générales vous indiquent qui
        nous sommes, comment nous vous fournirons les services, la manière dont nous pouvons (et
        vous pouvez) modifier ou cesser votre utilisation du service, quoi faire si un problème
        survient et d&apos;autres informations importantes.
      </p>
      <>
        Si vous n&apos;acceptez pas les présentes conditions générales, veuillez-vous abstenir
        d&apos;utiliser notre site.
      </>
    </section>

    <section>
      <h2>Mise à jour du site et des conditions</h2>
      <p>
        Nous nous réservons le droit de mettre à jour ou de changer ces conditions à tout moment en
        modifiant le contenu de cette page. Nous avertirons de ces changements en publiant les
        nouvelles conditions sur le site, avec leur nouvelle date d&apos;entrée en vigueur. Vous
        êtes censé consulter cette page de temps en temps pour prendre connaissance de tout
        changement éventuel de notre part. Nous sommes susceptibles de mettre à jour notre site et
        notre logiciel de temps à autre, en modifiant leur contenu à tout moment. Nous pouvons
        suspendre l&apos;accès à notre site ou au logiciel, ou les fermer pour une durée
        indéterminée si besoin. Tout contenu sur notre site est susceptible de ne plus être à jour
        et nous n&apos;avons aucune obligation de le mettre à jour. Nous ne garantissons pas que
        notre site ou le contenu qui s&apos;y trouve seront exempts d&apos;erreurs ou
        d&apos;omissions.
      </p>
    </section>
    <section>
      <h2>À propos de nous</h2>
      <p>
        www.qmee.com (&ldquo;Qmee&rdquo;) est un site exploité par Kantar UK Ltd
        (&laquo;&nbsp;nous&nbsp;&raquo;). Nous sommes immatriculés en Angleterre et au Pays de
        Galles sous le numéro de société 03073845 et notre siège social se trouve au Tns House,
        Westgate, London, W5 1UA, UK.
      </p>
    </section>
    <section>
      <h2>Comment nous contacter</h2>
      <p>
        Vous pouvez nous contacter via la rubrique <A href={CONTACT_US.path}>Nous contacter</A> sur
        notre site ou en nous envoyant un e-mail à cette adresse :{' '}
        <A href="mailto:support@qmee.com">support@qmee.com</A>.
      </p>
    </section>
    <section>
      <h2>Comment nous pouvons vous contacter</h2>
      <p>
        Si nous devons vous contacter, nous le ferons par écrit, à l&apos;adresse e-mail que vous
        nous aurez fournie à votre inscription.
      </p>
    </section>
    <section>
      <h2>Disponibilité du service</h2>
      <p>
        Notre service est prévu pour être utilisé par des personnes résidant au Royaume-Uni, aux
        États-Unis, au Canada, en Australie, en France ou en Allemagne, et y accédant depuis ces
        pays. Vous ne devez pas utiliser notre service si vous êtes résident d&apos;un autre pays.
        Nous ne garantissons pas que le contenu disponible sur ou via notre site est approprié ou
        disponible dans d&apos;autres lieux. À tout moment, nous sommes susceptibles de limiter la
        disponibilité de notre site, de notre service ou de notre logiciel à toute personne ou toute
        zone géographique. Si vous choisissez d&apos;accéder à notre site depuis un pays autre que
        le Royaume-Uni, les États-Unis, le Canada, l&apos;Australie, la France ou l&apos;Allemagne,
        vous devrez en assumer les risques.
      </p>
    </section>
    <section>
      <h2>Votre statut</h2>
      <p>
        En téléchargeant notre logiciel, vous confirmez que vous résidez légalement au Royaume-Uni,
        aux États-Unis, au Canada, en Australie, en France ou en Allemagne, que vous accédez à notre
        site depuis l&apos;un de ces pays et que vous avez au moins seize (16) ans. Vous ne pouvez
        posséder qu&apos;un seul compte utilisateur. Les revenus gains générés depuis des comptes
        supplémentaires ne seront pas nécessairement versés et nous aurons le droit de désactiver
        tout compte utilisateur supplémentaire, à tout moment.
      </p>
    </section>
    <section>
      <h2>Les services de Qmee</h2>
      <h3>Résultats sponsorisés</h3>
      <p>
        Le service que nous proposons via notre logiciel consiste à fournir des résultats
        sponsorisés lorsque vous effectuez des recherches sur certains moteurs de recherche tiers,
        en fonction de ce que vous tapez sur votre clavier. Les résultats sponsorisés seront
        affichés dans une fenêtre distincte et seront séparés de tout autre résultat sponsorisé
        affiché sur les pages de résultats du moteur de recherche. Sous réserve de votre respect des
        présentes conditions générales, lorsque vous cliquez sur un résultat sponsorisé dans la
        fenêtre Qmee, nous pouvons, conformément à notre politique de paiement des utilisateurs
        (telle que modifiée de temps à autre), créditer d&apos;une petite somme d&apos;argent
        (&laquo;&nbsp;un&nbsp;paiement&nbsp;&raquo;) le compte utilisateur que vous avez ouvert chez
        nous.
      </p>
      <h3>Récompenses financières pour des enquêtes</h3>
      <p>
        De temps à autre, nous pouvons proposer des récompenses financières aux utilisateurs qui
        répondent à des enquêtes. Sous réserve de votre respect des présentes conditions générales,
        lorsque vous répondez à une enquête, nous pouvons, conformément à la politique de paiement
        des utilisateurs (telle que modifiée de temps à autre), vous offrir une récompense sur votre
        compte Qmee. Les récompenses seront accordées uniquement pour les enquêtes auxquelles vous
        avez répondu intégralement. Des restrictions supplémentaires peuvent s&apos;appliquer à
        certaines enquêtes ou récompenses. Veuillez donc lire attentivement toutes les conditions
        générales qui s&apos;appliquent avant de décider de participer ou non à une enquête. Les
        contenus des enquêtes sont fournis par des tiers et leur utilisation pour ces enquêtes ne
        doit pas être interprété comme un soutien de notre part à ces tiers. Nous ne faisons aucune
        déclaration, ne donnons aucune garantie et n&apos;assumons aucune responsabilité quant au
        contenu des enquêtes menées par des tiers.
      </p>
      <p>
        Toutes les informations que vous communiquez dans le cadre d&apos;une enquête (notamment,
        mais sans s&apos;y restreindre, votre année de naissance, votre code postal, votre genre et
        vos réponses à l&apos;enquête) seront partagées avec le{' '}
        <A href={PARTNERS.path}>partenaire en charge de l&apos;enquête</A>. Les informations de
        l&apos;enquête pourront aussi être agrégées et partagées avec d&apos;autres tiers. Veuillez
        consulter notre déclaration de confidentialité pour de plus amples informations.
      </p>
      <h3>Récompenses financières pour des offres</h3>
      <p>
        De temps à autre, nous pouvons proposer des récompenses financières aux utilisateurs qui
        participent à l&apos;offre d&apos;un tiers. Sous réserve de votre respect des présentes
        conditions générales et des conditions générales indiquées pour chaque offre
        individuellement, lorsque vous répondez à une offre, nous pouvons, conformément à la
        politique de paiement des utilisateurs (telle que modifiée de temps à autre), vous offrir
        une récompense sur votre compte Qmee. Les récompenses seront accordées uniquement pour les
        offres qui sont promues par Qmee et auxquelles vous avez répondu intégralement. Nous ne
        pouvons être tenus responsables si le vendeur ne nous signale pas la vente à un utilisateur.
        Les vendeurs ont leurs propres règles pour déterminer quelles transactions sont légitimes.
        Par exemple, une tentative de gagner une récompense financière en cliquant ou en
        s&apos;inscrivant sur le site Web du vendeur, sans intention de continuer à l&apos;utiliser
        ou d&apos;y acheter quelque chose pourrait être considérée comme illégitime. Ces règles
        peuvent ou non être annoncées par Qmee ou le vendeur, et peuvent être discrétionnaires.
      </p>
      <h3>Incitations supplémentaires</h3>
      <p>
        De temps à autre, nous pouvons offrir des récompenses supplémentaires pour
        l&apos;accomplissement de certaines activités sur votre compte Qmee (comme des séries
        d&apos;enquêtes).
      </p>
      <p>
        Nous nous réservons le droit de limiter, de suspendre ou de retirer les récompenses
        supplémentaires à tout moment, ou de modifier les récompenses offertes.
      </p>
      <h3>Service de recherche de bonnes affaires</h3>
      <p>
        De temps à autre, nous pouvons vous informer par le biais de notre logiciel si nous pensons
        qu&apos;un produit que vous avez recherché en ligne est disponible à un prix inférieur sur
        un autre site. Nous ferons des efforts raisonnables pour nous assurer que le prix proposé
        est à jour et exact. Cependant, les prix affichés nous seront fournis par des tiers, par
        conséquent, nous ne garantissons pas que nous vous proposerons le prix le moins cher
        disponible pour le produit ou que le prix sera fiable, exact ou à jour. Par ailleurs, même
        si généralement, nous essayons de vous indiquer un prix inférieur à celui que vous
        consultez, nous ne garantissons pas être en mesure de le faire à chaque fois.
      </p>
      <p>
        Veuillez noter que les produits proposés sont fournis par des tiers et que tous les achats
        seront effectués depuis des sites tiers. Votre contrat pour ces produits sera conclu avec
        ces tiers, selon leurs conditions générales, et l&apos;indication d&apos;un prix plus bas ne
        doit pas être interprétée comme un soutien de notre part à ces tiers. Nous ne faisons aucune
        déclaration, ne donnons aucune garantie et n&apos;assumons aucune responsabilité quant au
        contenu des sites tiers. Nous n&apos;assumerons aucune responsabilité envers vous concernant
        ces achats.
      </p>
    </section>
    <section>
      <h2>Utilisation possible de vos informations personnelles</h2>
      <p>
        À la création de votre compte utilisateur, nous vous demanderons de nous fournir votre
        adresse e-mail et d&apos;indiquer votre pays de résidence. Nous conserverons également les
        détails des recherches que vous effectuez lorsque vous utilisez notre service. Lorsque vous
        effectuez une demande de retrait de votre solde (de récompenses) dans votre compte
        utilisateur, nous pouvons vous demander de nous fournir l&apos;option d&apos;envoyer des
        informations complémentaires, comme votre âge ou votre ville de résidence.
      </p>
      <p>
        Vous trouverez de plus amples informations sur la façon dont nous collectons et traitons vos
        données dans notre politique de confidentialité.
      </p>
    </section>
    <section>
      <h2>Réception de paiements</h2>
      <p>
        Vous ne pourrez recevoir des paiements crédités sur votre compte utilisateur que par
        l&apos;intermédiaire de PayPal ou d&apos;un autre fournisseur de paiement que nous mettrons
        à votre disposition de temps à autre. Vous pouvez également en faire don à l&apos;une des
        associations caritatives figurant sur une liste que nous vous indiquons, ou convertir
        l&apos;argent en cartes-cadeaux, que vous pouvez sélectionner parmi une liste mise à votre
        disposition. Pour commander une carte-cadeau, vous devrez faire vérifier votre identité.
        Nous vous indiquerons comment procéder ; il se peut que nous vous demandions d&apos;abord
        d&apos;encaisser un montant sur votre compte PayPal ou que nous vous demandions de passer
        par un autre service de vérification d&apos;identité. Si vous choisissez d&apos;effectuer un
        retrait sous la forme d&apos;une carte-cadeau, un code vous sera communiqué pour la
        récupérer. Nous n&apos;assumons aucune responsabilité concernant le code émis et nous ne
        pourrons pas le rééditer. Nous nous réservons le droit de retirer toutes les cartes-cadeaux
        proposées à tout moment. Vous pourrez utiliser le solde de votre compte utilisateur à tout
        moment, mais certaines cartes-cadeaux peuvent être soumises à un seuil minimum de retrait
        (par exemple, 5 £/5 $ / 5€). Veuillez consulter les informations spécifiques fournies pour
        chaque carte-cadeau au cours de la procédure de retrait, pour connaître ces seuils minimums.
        Les options de retrait du solde de votre compte utilisateur sont soumises à des changements,
        dont nous vous informerons dans des délais raisonnables. Nous ne serons pas responsables des
        paiements qui vous sont dus si vous nous fournissez un numéro de compte PayPal ou
        d&apos;autres informations de paiement incorrectes. Nous ne serons pas non plus responsables
        des paiements qui vous sont dus en cas d&apos;erreur catastrophique dans les données, le
        logiciel ou le serveur, de cyberattaque ou de tout autre événement nous empêchant de
        déterminer les paiements qui ont été accumulés.
      </p>
      <p>
        Nous sommes autorisés à suspendre votre compte utilisateur à tout moment, à notre seule
        discrétion. Si votre compte n&apos;a pas été utilisé pendant un (1) an ou plus, nous
        conserverons le solde sur votre compte, ou nous vous le verserons. Nous pouvons également
        suspendre votre utilisation de notre service à tout moment, à notre seule discrétion.
      </p>
      <p>
        Vous reconnaissez et acceptez que nous n&apos;avons pas la capacité de déterminer si les
        récompenses financières que vous avez gagnées ou récupérées par l&apos;intermédiaire de
        votre compte Qmee sont considérées comme des revenus imposables dans votre juridiction. Vous
        êtes donc responsable de toute obligation fiscale découlant de, ou associée à, votre
        utilisation du site Web et de l&apos;application Qmee, y compris toute obligation liée à
        votre accumulation de récompenses financières ou de votre encaissement de ces récompenses
        financières. Comme condition de votre utilisation continue du site Web et de
        l&apos;application Qmee, nous nous réservons le droit de vous demander de fournir les
        informations fiscales nécessaires si nos dossiers indiquent que vous êtes, ou pourriez être,
        tenu de déclarer la valeur des récompenses financières à une autorité fiscale compétente.
        Vous trouverez l&apos;historique complet de vos récompenses financières dans l&apos;onglet
        Historique de votre compte Qmee, sur votre tableau de bord. Comme les questions fiscales
        relèvent de votre responsabilité, nous vous recommandons de demander conseil à un expert
        dans ce domaine, pour déterminer quelles sont les conséquences, en matière de fiscalité, de
        l&apos;utilisation du site Web et de l&apos;application Qmee, et de toute perception ou de
        tout retrait de récompenses financières associées.
      </p>
      <p>
        Qmee utilise les services de Hyperwallet pour vous verser des paiements. Ces services de
        paiement sont soumis aux{' '}
        <A
          target="_blank"
          href="https://pay.hyperwallet.com/hw2web/consumer/page/legalAgreement.xhtml"
        >
          conditions d&apos;utilisation
        </A>{' '}
        et à la{' '}
        <A
          target="_blank"
          href="https://pay.hyperwallet.com/hw2web/consumer/page/legalAgreement.xhtml"
        >
          politique de confidentialité de Hyperwallet
        </A>
      </p>
    </section>
    <section>
      <h2>Système de parrainage</h2>
      <p>
        De temps à autre, nous pourrons proposer un système de parrainage à des utilisateurs de
        notre choix. Pour chaque filleul qui s&apos;inscrit chez Qmee via votre lien de parrainage,
        vous recevrez une récompense sur votre compte Qmee dès son premier retrait sous la forme
        d&apos;un paiement via PayPal ou d&apos;une carte cadeau. Pour recevoir cette récompense,
        vos filleuls doivent passer par votre lien de parrainage.
      </p>
      <p>Nous nous réservons le droit de suspendre le système de parrainage à tout moment.</p>
    </section>
    <section>
      <h2>Accès à notre service</h2>
      <p>
        Nous accordons l&apos;accès à notre service pour une durée limitée et nous nous réservons le
        droit de retirer ou de modifier le service que nous vous fournissons sans avertissement
        (voir plus bas). Nous ne serons pas responsables si, pour quelque raison que ce soit, notre
        service est indisponible à tout moment ou pendant toute période.
      </p>
      <p>
        De temps à autre, nous pouvons limiter l&apos;accès des utilisateurs qui se sont inscrits
        chez nous à certaines parties de notre site, ou à l&apos;ensemble de notre site.
      </p>
      <p>
        Vous ne devez pas autoriser d&apos;autres personnes à utiliser votre compte utilisateur.
        Vous devez veiller à ce que l&apos;identifiant de votre compte utilisateur et votre mot de
        passe restent confidentiels, et ne pas les divulguer à des tiers. Nous avons le droit de
        désactiver à tout moment tout identifiant de compte utilisateur ou mot de passe, qu&apos;il
        ait été choisi par vous ou attribué par nous, si nous estimons que vous n&apos;avez pas
        respecté l&apos;une des dispositions des présentes conditions générales.
      </p>
    </section>
    <section>
      <h2>Droits de propriété intellectuelle</h2>
      <p>
        Nous sommes les détenteurs de tous les droits de propriété intellectuelle sur notre service,
        notamment notre site et notre logiciel, ou les titulaires de licence sur ces droits. Ces
        œuvres sont protégées par les lois et les traités sur le droit d&apos;auteur du monde
        entier. L&apos;ensemble desdits droits sont réservés. Aucun de ces contenus ne peut être
        reproduit ou redistribué sans notre autorisation écrite. Vous pouvez toutefois télécharger
        ou imprimer un exemplaire unique des informations à l&apos;écran pour votre usage personnel.
      </p>
      <p>
        Si vous imprimez, copiez ou téléchargez une partie de notre service en violation des
        présentes conditions générales, votre droit d&apos;utiliser celui-ci prendra fin
        immédiatement et vous devrez, à notre discrétion, rendre ou détruire les copies des
        documents que vous avez effectuées.
      </p>
      <p>Qmee est une marque commerciale de Kantar UK Ltd enregistrée en UE et aux États-Unis.</p>
    </section>
    <section>
      <h2>Notre responsabilité</h2>
      <p>
        Si nous ne respectons pas ces conditions, nous sommes responsables des pertes ou des
        dommages que vous subissez et qui sont le résultat prévisible de notre violation du présent
        contrat ou de notre manque d&apos;attention et de compétence raisonnables, mais nous ne
        sommes pas responsables des pertes ou des dommages qui ne sont pas prévisibles. Une perte ou
        un dommage est prévisible s&apos;il est évident qu&apos;il se produira ou si, au moment où
        le contrat a été conclu, vous et nous savions qu&apos;il pourrait se produire.
      </p>
      <p>
        Nous ne sommes pas responsables des manquements à la fourniture de nos services, ou des
        manquements ou retards dans le respect des obligations qui nous incombent en vertu des
        présentes conditions générales, s&apos;ils sont dus à des raisons échappant à notre contrôle
        raisonnable.
      </p>
      <p>
        Nous ne sommes pas responsables des pertes commerciales. Nous fournissons le service et le
        logiciel uniquement pour un usage domestique privé. Nous n&apos;aurons aucune responsabilité
        envers vous si vous subissez une perte de profit, une perte d&apos;activité, une
        interruption d&apos;activité ou une perte d&apos;opportunité commerciale après avoir utilisé
        le service ou le logiciel à des fins commerciales, professionnelles ou de revente.
      </p>
      <p>
        Aucune disposition des présentes conditions ne limite notre responsabilité en cas de décès
        ou de dommages corporels résultant de notre négligence, ni notre responsabilité en cas de
        déclaration frauduleuse ou erronée sur un point essentiel, ni aucune autre responsabilité
        qui ne peut être exclue ou limitée en vertu de la législation applicable.
      </p>
      <p>
        Lorsque nous fournissons notre service, nous fournissons des liens vers des sites Web tiers.
        Nous n‘assumons aucune responsabilité concernant le contenu des sites Web tiers dont nous
        partageons les liens. Le partage de ces sites Web ne saurait être interprété comme une
        validation de notre part des contenus qu&apos;ils renferment. Nous ne serons responsables
        d&apos;aucune perte ni d&apos;aucun dommage qui pourrait survenir suite à votre utilisation
        de ces sites.
      </p>
    </section>
    <section>
      <h2>Mauvais usage du compte</h2>
      <p>
        Notre service est destiné à récompenser les comportements normaux de navigation sur Internet
        et vous ne devez pas cliquer sur un résultat sponsorisé si vous n&apos;avez pas
        d&apos;intérêt réel pour ce dernier, ni répondre à des enquêtes de manière inexacte. Si nous
        estimons (ou si nos algorithmes suggèrent) que vous abusez de notre service, notamment en
        cliquant sur des résultats sponsorisés qui ne vous intéressent pas vraiment, en cliquant sur
        un résultat sponsorisé à plusieurs reprises ou en répondant à des enquêtes en utilisant des
        informations inexactes ou frauduleuses, nous sommes en droit, à notre seule discrétion, de
        réduire le montant des paiements qui vous sont versés ou de cesser complètement de vous
        verser des paiements.
      </p>
      <p>
        Vous ne devez pas faire un mauvais usage de notre service en introduisant sciemment des
        virus, des chevaux de Troie, des vers, des bombes logiques ou d&apos;autres éléments
        malveillants ou technologiquement nuisibles.
      </p>
      <p>
        Vous ne devez pas essayer d&apos;obtenir un accès non autorisé à notre service (notamment
        notre site), au serveur sur lequel notre site est stocké ou aux serveurs, ordinateurs ou
        bases de données connectées à notre service. Vous ne devez pas attaquer notre service au
        moyen d&apos;une attaque par déni de service ou une attaque par déni de service distribué.
      </p>
      <p>
        La violation de cette disposition constituerait une infraction pénale en vertu de la loi
        britannique de 1990 relative à l&apos;usage abusif de l&apos;informatique (Computer Misuse
        Act 1990). Nous signalerons ces violations aux forces de l&apos;ordre compétentes et
        coopérerons avec elles en leur dévoilant votre identité. En cas de violation de ce type,
        votre droit d&apos;utiliser notre service (y compris notre site) prendra fin immédiatement.
      </p>
    </section>
    <section>
      <h2>Fiabilité des informations publiées</h2>
      <p>
        Les commentaires et autres contenus publiés sur notre site ou autrement fournis par notre
        service ne sont pas destinés à constituer des conseils sur lesquels vous pourriez vous
        appuyer. Nous déclinons donc toute responsabilité découlant de la confiance accordée à ces
        contenus par vous ou par toute personne qui pourrait être informée de ces contenus.
      </p>
    </section>
    <section>
      <h2>Compétence et loi applicable</h2>
      <p>
        Les tribunaux anglais seront les seuls compétents pour toute réclamation relative à une
        visite sur notre site ou à l&apos;utilisation de notre service, même si nous nous réservons
        le droit d&apos;engager une procédure contre vous pour violation des présentes conditions
        dans votre pays de résidence ou dans tout autre pays concerné.
      </p>
      <p>
        Les présentes conditions d&apos;utilisation et tout litige ou réclamation en découlant ou
        lié à son objet ou sa formation (y compris les litiges ou réclamations non contractuels)
        sont régis par le droit d&apos;Angleterre et du Pays de Galles, et doivent être interprétés
        en vertu de celui-ci. Toutefois, si vous résidez en Irlande du Nord, vous pouvez également
        engager une procédure en Irlande du Nord, et si vous résidez en Écosse, vous pouvez
        également engager une procédure en Écosse.
      </p>
      <p>
        Si vous résidez aux États-Unis, le présent accord sera régi et interprété conformément aux
        lois de l&apos;État de New York, sans tenir compte des principes de conflit de lois. Vous
        acceptez de porter en premier lieu toute affaire relative à un litige en vertu des présentes
        devant un arbitre, dans le cadre d&apos;un arbitrage final, contraignant et sans appel à New
        York, NY, conformément aux règles de l&apos;American Arbitration Association. Chaque partie
        devra partager les coûts de l&apos;arbitrage de manière égale et si l&apos;arbitre décide
        que les frais d&apos;arbitrage constituent un préjudice pour vous, il peut autoriser Qmee à
        payer 100 % des frais d&apos;arbitrage (à l&apos;exclusion des frais d&apos;avocat, qui
        doivent être supportés par vous). Vous pouvez également participer à l&apos;arbitrage par
        téléphone, si vous n&apos;êtes pas en mesure de vous rendre à New York. Vous acceptez
        d&apos;intenter toute action en vertu des présentes à titre individuel et non en tant que
        membre d&apos;un groupe ou d&apos;une partie d&apos;un quelconque type d&apos;action
        collective. VOUS COMPRENEZ QUE SANS LES OBLIGATIONS ÉNONCÉES DANS LA PRÉSENTE CLAUSE, VOUS
        AURIEZ DROIT À UN PROCÈS AVEC JURY ET VOUS RENONCEZ PAR LA PRÉSENTE À CE DROIT. Une sentence
        arbitrale peut être rendue par tout tribunal compétent. Nonobstant toute disposition
        contraire des présentes, vous acceptez que Qmee puisse intenter une action relative à ses
        droits de propriété intellectuelle, y compris une injonction liée à ces droits, devant tout
        tribunal compétent, sans recourir au mécanisme d&apos;arbitrage prévu par les présentes.
        Vous reconnaissez et acceptez que les exclusions de garantie et les limitations de
        responsabilité et de recours figurant dans le présent accord sont des conditions
        essentielles de cet accord, et qu&apos;elles ont été prises en compte dans la décision de
        Qmee de fournir le service. Vous ne pouvez céder aucun de vos droits, obligations ou
        privilèges sans l&apos;autorisation écrite préalable de Qmee. Le présent accord et toute
        règle de fonctionnement publiée par Qmee constituent l&apos;intégralité de l&apos;accord
        entre les parties concernant l&apos;objet du présent accord, et remplacent toutes les
        communications et propositions antérieures ou concomitantes, qu&apos;elles soient orales ou
        écrites, entre les parties concernant l&apos;objet du présent accord, et remplacent toutes
        les communications et propositions antérieures ou concomitantes, qu&apos;elles soient orales
        ou écrites, entre les parties concernant un tel objet.
      </p>
    </section>
    <section>
      <h2>Résolution de litige alternative</h2>
      <p>
        Une résolution de litige alternative est une procédure où un organisme indépendant prend en
        compte les faits du litige et cherche à le résoudre, sans que vous ayez à vous rendre dans
        un tribunal. Si vous n&apos;êtes pas satisfait de la manière dont nous avons traité une
        plainte, vous pouvez soumettre vos litiges à la plateforme de règlement en ligne des litiges
        de la Commission européenne, à l&apos;adresse suivante :{' '}
        <A target="_blank" href="https://ec.europa.eu/consumers/odr/">
          https://ec.europa.eu/consumers/odr/
        </A>
        .
      </p>
    </section>
    <section>
      <h2>Vos préoccupations</h2>
      <p>
        Si vous avez des questions ou plaintes concernant notre site, nos services, notre logiciel
        ou votre compte utilisateur, veuillez contacter{' '}
        <A href="mailto:support@qmee.com">support@qmee.com</A>. Notre service affiche du contenu qui
        appartient à des tiers ou qui est mis à disposition par ces derniers (résultats de
        recherches sponsorisés, enquêtes). Ces tiers sont les seuls responsables de ce contenu. Vous
        pouvez vérifier la légalité et la conformité d&apos;un contenu par rapport à nos politiques,
        et nous pouvons retirer ou refuser d&apos;afficher des contenus dont nous estimons
        raisonnablement qu&apos;ils ne sont pas conformes. Toutefois, nous ne vérifions pas
        systématiquement le contenu et il convient de ne pas partir du principe que nous le faisons.
        Si vous avez des préoccupations concernant le contenu affiché dans le cadre de notre
        service, veuillez contacter <A href="mailto:support@qmee.com">support@qmee.com</A>.
      </p>
      <p>Nous vous remercions d&apos;avoir visité notre site.</p>
      <p>
        <em>Dernière mise à jour : Février 2026</em>
      </p>
    </section>
  </>
);

export const deTermsConditions = (
  <>
    <section>
      <h1>Allgemeine Geschäftsbedingungen</h1>
      <p>
        Diese Seite (zusammen mit den Richtlinien und anderweitigen Bedingungen, auf die verwiesen
        wird) informiert Sie über die Geschäftsbedingungen, nach denen wir Ihnen, sei es als Gast
        oder als registriertem Nutzer, unsere Dienste <strong>(„unsere Dienste“)</strong>{' '}
        einschließlich unserer Website www.qmee.com <strong>(„unsere Website“)</strong> sowie den
        Qmee-Browser und die mobilen Anwendungen <strong>(„unsere Software“)</strong> bereitstellen.
        Bitte lesen Sie diese Geschäftsbedingungen sorgfältig und vergewissern Sie sich, dass Sie
        sie verstanden haben, bevor Sie diese Website, unsere Dienste oder unsere Software nutzen.
        Sie sollten eine Kopie dieser Geschäftsbedingungen ausdrucken, um später darauf Bezug nehmen
        zu können. In diesen Geschäftsbedingungen erfahren Sie, wer wir sind, wie wir Ihnen unsere
        Dienste zur Verfügung stellen, wie Sie und wir Ihre Nutzung des Dienstes ändern oder beenden
        können, was zu tun ist, wenn ein Problem auftritt, und andere wichtige Informationen.
      </p>
      <p>
        Wenn Sie diesen Nutzungsbedingungen nicht zustimmen, sehen Sie bitte von der Nutzung unserer
        Website ab.
      </p>
    </section>
    <section>
      <h2>Aktualisierung der Website und der Geschäftsbedingungen</h2>
      <p>
        Wir behalten uns das Recht vor, diese Geschäftsbedingungen jederzeit zu aktualisieren oder
        zu ändern, indem wir diese Seite ergänzen. Wir werden über Änderungen der
        Geschäftsbedingungen Mitteilung machen, indem wir die neuen Geschäftsbedingungen mit einem
        neuen Wirksamkeitsdatum auf der Website veröffentlichen. Sie sollten diese Seite von Zeit zu
        Zeit überprüfen, um sich über eventuelle Änderungen zu informieren. Wir können unsere
        Website und Software von Zeit zu Zeit aktualisieren und die Inhalte jederzeit ändern. Falls
        erforderlich, können wir den Zugriff auf unserer Website oder Software zeitweilig aussetzen
        oder diese auf unbestimmte Zeit einstellen. Das Material auf unserer Website kann zuweilen
        veraltet sein. Wir sind nicht verpflichtet, dieses Material zu aktualisieren. Wir
        garantieren nicht, dass unsere Website oder deren Inhalte frei von Irrtümern oder
        Auslassungen sind.
      </p>
    </section>
    <section>
      <h2>Informationen über uns</h2>
      <p>
        www.qmee.com („Qmee“) ist eine von Kantar UK Ltd <strong>(„wir“)</strong> betriebene
        Website. Wir sind ein in England und Wales unter der Firmennummer 03073845 eingetragenes
        Unternehmen mit Geschäftssitz in Tns House, Westgate, London, W5 1UA, UK.
      </p>
    </section>
    <section>
      <h2>Wie Sie uns kontaktieren können</h2>
      <p>
        Sie können sich mit uns über den Link <A href={CONTACT_US.path} target="_blank"></A>
        Kontakt auf unserer Website oder per E-Mail an{' '}
        <A href="mailto:support@qmee.com">support@qmee.com</A> in Verbindung setzen.
      </p>
    </section>
    <section>
      <h2>Wie wir Sie kontaktieren können</h2>
      <p>
        Wenn wir uns mit Ihnen in Verbindung setzen müssen, schicken wir Ihnen eine Mitteilung an
        die E-Mail-Adresse, die Sie uns bei der Registrierung angegeben haben.
      </p>
    </section>
    <section>
      <h2>Verfügbarkeit des Dienstes</h2>
      <p>
        Unser Dienst ist ausschließlich zur Inanspruchnahme von Personen mit Wohnsitz im Vereinigten
        Königreich, in den USA, in Kanada, Australien, Frankreich oder Deutschland bestimmt, die von
        diesen Ländern aus auf den Dienst zugreifen. Sie sollten unseren Dienst nicht nutzen, wenn
        Sie in einem anderen Land ansässig sind. Wir sichern nicht zu, dass die auf oder über unsere
        Website verfügbaren Inhalte an anderen Standorten angemessen oder verfügbar sind. Wir können
        die Verfügbarkeit unserer Website, unseres Dienstes oder unserer Software jederzeit auf
        bestimmte Personen oder ein geografisches Gebiet beschränken. Ihr Zugriff auf unsere Website
        von einem Standort außerhalb des Vereinigten Königreichs, der USA, von Kanada, Australien,
        Frankreich oder Deutschland erfolgt auf eigenes Risiko.
      </p>
    </section>
    <section>
      <h2>Ihr Status</h2>
      <p>
        Durch das Herunterladen unserer Software bestätigen Sie, dass Sie sich im Vereinigten
        Königreich, in den USA, in Kanada, Australien, Frankreich oder Deutschland rechtmäßig
        aufhalten dürfen, dass Sie von diesem Land aus auf unsere Website zugreifen und dass Sie
        mindestens sechzehn (16) Jahre alt sind. Sie dürfen nur ein Nutzerkonto haben. Die auf
        zusätzlichen Nutzerkonten erzielten Einkünfte werden nicht notwendigerweise ausgezahlt. Wir
        haben das Recht, zusätzliche Nutzerkonten jederzeit zu deaktivieren.
      </p>
    </section>
    <section>
      <h2>Qmee-Dienste</h2>
      <h3>Gesponserte Ergebnisse</h3>
      <p>
        Der über unsere Software bereitgestellte Dienst liefert gesponserte Ergebnisse, wenn Sie in
        bestimmten Suchmaschinen von Drittanbietern suchen, basierend auf Ihren Tastatureingaben.
        Die gesponserten Ergebnisse werden in einem separaten Fenster angezeigt und sind von den
        gesponserten Ergebnissen, die auf den Ergebnisseiten der Suchmaschine angezeigt werden,
        getrennt. Wenn Sie auf ein gesponsertes Ergebnis im Qmee-Fenster klicken, können wir in
        Übereinstimmung mit unseren Zahlungsrichtlinien für Nutzer (in der jeweils gültigen Fassung)
        einen kleinen Geldbetrag („eine Zahlung“) dem von Ihnen bei uns registrierten Nutzerkonto
        gutschreiben, sofern Sie diese Geschäftsbedingungen einhalten.
      </p>
      <h3>Geldprämien für Umfragen</h3>
      <p>
        Von Zeit zu Zeit können wir Nutzern, die an Umfragen teilnehmen, Geldprämien anbieten. Wenn
        Sie eine Umfrage abschließen, können wir Ihnen, vorbehaltlich Ihrer Einhaltung dieser
        Geschäftsbedingungen, in Übereinstimmung mit unseren Zahlungsrichtlinien für Nutzer (in der
        jeweils gültigen Fassung) eine Prämie auf Ihrem
      </p>
      <p>
        Qmee-Konto gutschreiben. Prämien werden nur für Umfragen gutgeschrieben, die vollständig
        abgeschlossen sind. Zusätzliche Beschränkungen für bestimmte Umfragen oder Prämien sind
        möglich. Bitte lesen Sie daher alle anwendbaren Geschäftsbedingungen sorgfältig durch, bevor
        Sie sich für oder gegen eine Teilnahme an der Umfrage entscheiden. Die Inhalte der Umfragen
        werden von Dritten zur Verfügung gestellt. Diese Umfragen sollten nicht als Befürwortung
        dieser Dritten unsererseits ausgelegt werden. Wir geben keine Garantien oder Zusicherungen
        und übernehmen keine Verantwortung für den Inhalt der Umfragen Dritter.
      </p>
      <p>
        Informationen, die Sie im Rahmen einer Umfrage übermitteln (einschließlich, aber nicht
        beschränkt auf Ihr Geburtsjahr, Ihre Postleitzahl, Ihr Geschlecht und Ihre
        Umfrageantworten), werden an den jeweiligen{' '}
        <A href="https://www.qmee.com/de-de/partners">Umfragepartner</A> weitergegeben. Die
        Umfragedaten können ferner zusammengefasst und an andere Dritte weitergegeben werden.
        Weitere Einzelheiten entnehmen Sie bitte unserem Datenschutzhinweis.
      </p>
      <h3>Geldprämien für Angebote</h3>
      <p>
        Von Zeit zu Zeit können wir Nutzern, die ein Angebot eines Dritten wahrnehmen, Geldprämien
        anbieten. Vorbehaltlich Ihrer Einhaltung dieser Geschäftsbedingungen sowie der
        Geschäftsbedingungen, die bei jedem einzelnen Angebot anzeigt werden, können wir bei
        Vervollständigung eines Angebots in Übereinstimmung mit unseren Zahlungsrichtlinien für
        Nutzer (in der jeweils gültigen Fassung) Ihrem Qmee-Konto eine Prämie gutschreiben. Prämien
        werden nur für Angebote gutgeschrieben, die von Qmee beworben und vollständig abgeschlossen
        sind. Wir können nicht zur Verantwortung gezogen werden, wenn uns der Händler den Verkauf
        eines Nutzers nicht meldet. Die Händler haben ihre eigenen Regeln, nach denen sie
        Transaktionen als echt einstufen. So könnte beispielsweise ein Versuch, durch
        Anklicken/Registrierung eine Geldprämie zu verdienen, ohne die Absicht, die Website des
        Händlers weiter zu nutzen/auf der Website des Händlers einzukaufen, als nicht echt
        eingestuft werden. Diese Regeln können von Qmee oder dem Händler angezeigt werden oder auch
        nicht, und können im Ermessen des Händlers liegen.
      </p>
      <h3>Zusätzliche Anreize für Aktivitäten</h3>
      <p>
        Von Zeit zu Zeit können wir zusätzliche Prämien für den Abschluss bestimmter Aktivitäten
        innerhalb Ihres Qmee-Kontos anbieten (z. B. Umfrageserien).
      </p>
      <p>
        Wir behalten uns das Recht vor, die zusätzlichen Prämien jederzeit zu begrenzen, auszusetzen
        oder zurückzuziehen oder die angebotenen Prämien zu ändern.
      </p>
      <h3>Schnäppchenfinder-Dienst</h3>
      <p>
        Von Zeit zu Zeit können wir Sie über unsere Software benachrichtigen, wenn wir der Ansicht
        sind, dass ein Produkt, nach dem Sie online gesucht haben, auf einer anderen Website zu
        einem geringeren Preis erhältlich ist. Wir werden angemessene Anstrengungen unternehmen, um
        sicherzustellen, dass der angebotene Preis aktuell und korrekt ist. Die angezeigten Preise
        werden uns jedoch von Dritten zur Verfügung gestellt, so dass wir nicht garantieren können,
        dass wir Ihnen den günstigsten verfügbaren Preis für das Produkt anbieten oder dass der
        Preis zuverlässig, korrekt oder aktuell ist. Wir bemühen uns zwar, Sie über einen Preis zu
        benachrichtigen, der günstiger ist als der Preis, den Sie gerade sehen, aber wir können
        nicht garantieren, dass dies stets der Fall ist.
      </p>
      <p>
        Bitte beachten Sie, dass die angebotenen Produkte von Dritten zur Verfügung gestellt werden
        und alle Käufe über die Websites Dritter erfolgen. Ihr Vertrag für diese Produkte kommt mit
        diesen Dritten und zu deren jeweiligen Geschäftsbedingungen zustande, und die Mitteilung
        über die Preisdifferenz sollte nicht als Befürwortung dieser Dritten durch uns ausgelegt
        werden. Wir geben keine Garantien oder Zusicherungen über die Inhalte der Websites Dritter
        und übernehmen diesbezüglich keine Verantwortung, und wir unterliegen Ihnen gegenüber keiner
        Haftung für solche Käufe.
      </p>
    </section>
    <section>
      <h2>Wie wir Ihre personenbezogenen Daten verwenden können</h2>
      <p>
        Bei der Erstellung Ihres Nutzerkontos werden Sie aufgefordert, Ihre E-Mail-Adresse und Ihr
        Wohnsitzland anzugeben. Wir speichern außerdem Einzelheiten zu Ihren bei der Nutzung des
        Dienstes durchgeführten Suchvorgängen. Wenn Sie eine Auszahlung Ihres Guthabens auf Ihrem
        Nutzerkonto beantragen, können wir Ihnen die Option anbieten, weitere Informationen zu
        übermitteln, zum Beispiel Ihr Alter oder Ihren Wohnort.
      </p>
      <p>
        Weitere Informationen darüber, wie wir Ihre Daten erheben und verarbeiten, entnehmen Sie
        bitte unserer Datenschutzrichtlinie.
      </p>
    </section>
    <section>
      <h2>Empfang von Zahlungen</h2>
      <p>
        Sie können Zahlungen, die Ihrem Nutzerkonto gutgeschrieben werden, nur über PayPal oder über
        einen anderen Zahlungsanbieter erhalten, den wir von Zeit zu Zeit verfügbar machen.
        Alternativ können Sie diese an eine der verschiedenen Wohltätigkeitsorganisationen aus einer
        von uns festgelegten Liste spenden oder sich eine Geschenkkarte aus einer von uns
        festgelegten Liste auszahlen lassen. Um eine Geschenkkarte anzufordern, ist es erforderlich,
        Ihre Identität zu verifizieren. Wir werden Ihnen mitteilen, wie dies zu erfolgen hat. Sie
        können sich zunächst einen beliebigen Betrag auf Ihr PayPal-Konto auszahlen lassen oder
        einen alternativen Dienst zur Identitätsprüfung in Anspruch nehmen. Wenn Sie sich für eine
        Auszahlung auf eine Geschenkkarte entscheiden, erhalten Sie einen Code, mit dem Sie Ihre
        Geschenkkarte einlösen können. Wir übernehmen keine Verantwortung für den ausgegebenen Code
        und können ihn nicht erneut ausgeben. Wir behalten uns das Recht vor, angebotene
        Geschenkgutscheine jederzeit zu entfernen. Sie können Ihr Guthaben auf dem Nutzerkonto
        jederzeit einlösen. Einige Geschenkgutscheine können jedoch einen Mindesteinlösebetrag
        enthalten (z. B. £5/$5/ 5€). Bitte beachten Sie die spezifischen Informationen zu den
        einzelnen Geschenkkarten während des Einlösevorgangs in Bezug auf Einzelheiten über etwaige
        Mindesteinlösebeträge. Die Optionen für die Einlösung des Guthabens auf Ihrem Nutzerkonto
        können von uns nach angemessener Ankündigung geändert werden. Wir haften nicht für
        Zahlungen, die Ihnen geschuldet werden, wenn Sie uns eine falsche PayPal-Kontonummer oder
        andere relevante fehlerhafte Angaben machen. Wir haften auch nicht für Ihnen geschuldete
        Zahlungen im Falle eines katastrophalen Daten-, Software- oder Serverfehlers, eines
        Cyberangriffs oder eines anderen Ereignisses, das es uns unmöglich macht, die aufgelaufenen
        Zahlungen zu ermitteln.
      </p>
      <p>
        Wir sind berechtigt, Ihr Nutzerkonto jederzeit nach unserem alleinigen Ermessen zu sperren.
        Wenn Ihr Konto ein (1) Jahr lang oder länger nicht genutzt wurde, behalten wir das Guthaben
        auf dem Konto ein, andernfalls zahlen wir Ihnen das Guthaben auf dem Konto aus. Wir können
        Ihre Nutzung unseres Dienstes außerdem jederzeit nach unserem alleinigen Ermessen aussetzen.
      </p>
      <p>
        Sie erkennen an und erklären sich damit einverstanden, dass wir nicht in der Lage sind, zu
        ermitteln, ob die Geldprämien, die Sie über Ihr Qmee-Konto verdient oder eingelöst haben, in
        Ihrer Gerichtsbarkeit als meldepflichtiger steuerpflichtiger Verdienst gelten oder nicht.
        Sie sind daher für alle steuerlichen Verpflichtungen verantwortlich, die sich aus Ihrer
        Nutzung der Qmee-Website und der Qmee-App ergeben oder die damit verbunden sind,
        einschließlich der Verpflichtungen, die sich aus dem Erwerb von Geldprämien oder der
        Einlösung solcher Geldprämien ergeben. Als Bedingung für Ihre fortgesetzte Nutzung der
        Qmee-Website und -App behalten wir uns das Recht vor, Sie aufzufordern, die erforderlichen
        Steuererklärungen abzugeben, wenn unsere Aufzeichnungen zeigen, dass Sie den Wert der
        Geldprämien an eine zuständige Steuerbehörde melden müssen oder können. Sie finden Ihre
        vollständige Geldprämienhistorie auf der Registerkarte „Chronik“ Ihres Qmee-Kontos in Ihrem
        Dashboard. Wir empfehlen Ihnen, sich von einem Steuerexperten beraten zu lassen, um die
        steuerlichen Folgen Ihrer Nutzung der Qmee-Website und -App und der damit verbundenen
        verdienten oder eingelösten Geldprämien zu ermitteln, da dies in Ihrer Verantwortung liegt.
      </p>
      <p>
        Qmee nutzt die Zahlungsdienste von Hyperwallet, um Zahlungen an Sie zu leisten. Diese
        Zahlungsdienste unterliegen den{' '}
        <A href="https://pay.hyperwallet.com/hw2web/consumer/page/legalAgreement.xhtml">
          Hyperwallet Allgemeinen Geschäftsbedingungen
        </A>{' '}
        und den{' '}
        <A href="https://pay.hyperwallet.com/hw2web/consumer/page/legalAgreement.xhtml">
          Hyperwallet Datenschutzrichtlinie
        </A>
        .
      </p>
    </section>
    <section>
      <h2>Freunde-werben-Freunde-Programm</h2>
      <p>
        Von Zeit zu Zeit können wir Nutzern, die von uns bestimmt werden, ein
        Freunde-werben-Freunde-Programm anbieten. Für jeden Geworbenen, der sich über Ihren
        Empfehlungslink bei Qmee anmeldet, erhalten Sie eine Prämie auf Ihrem Qmee-Konto bei der
        ersten Auszahlung des Geworbenen auf PayPal oder eine Geschenkkarte. Damit Sie die Prämie
        erhalten, muss der Geworbene Ihrem Empfehlungs-Link folgen.
      </p>
      <p>Wir behalten uns das Recht vor, das Empfehlungsprogramm jederzeit auszusetzen.</p>
    </section>
    <section>
      <h2>Zugriff auf unseren Dienst</h2>
      <p>
        Der Zugriff auf unseren Dienst ist für eine befristete Zeit gestattet, und wir behalten uns
        das Recht vor, den von uns angebotenen Dienst ohne Vorankündigung einzustellen oder zu
        ändern (siehe unten). Wir übernehmen keine Haftung, wenn unser Dienst aus irgendeinem Grund
        zu irgendeinem Zeitpunkt oder für irgendeinen Zeitraum nicht verfügbar ist.
      </p>
      <p>
        Von Zeit zu Zeit können wir den Zugang zu einigen Teilen unserer Website oder unserer
        gesamten Website auf Nutzer beschränken, die sich bei uns registriert haben.
      </p>
      <p>
        Sie dürfen keiner anderen Person erlauben, Ihr Nutzerkonto zu nutzen. Sie müssen Ihre
        Nutzerkonto-ID und Ihr Passwort vertraulich behandeln und dürfen diese nicht an Dritte
        weitergeben. Wir haben das Recht, eine von Ihnen gewählte oder von uns zugewiesene
        Nutzerkonto-ID oder ein Passwort jederzeit zu deaktivieren, wenn Sie unserer Meinung nach
        gegen eine der Bestimmungen dieser Geschäftsbedingungen verstoßen haben.
      </p>
    </section>
    <section>
      <h2>Rechte an geistigem Eigentum</h2>
      <p>
        Wir sind Eigentümer oder Lizenznehmer aller geistigen Eigentumsrechte an unserem Dienst,
        einschließlich unserer Website und unserer Software. Diese Werke sind durch
        Urheberrechtsgesetze und -verträge weltweit geschützt. Alle diese Rechte sind vorbehalten.
        Keine dieser Materialien dürfen ohne unsere schriftliche Genehmigung vervielfältigt oder
        weiterverbreitet werden. Sie dürfen jedoch eine einzelne Kopie der auf dem Bildschirm
        angezeigten Informationen für Ihren eigenen privaten Gebrauch herunterladen oder ausdrucken.
      </p>
      <p>
        Wenn Sie einen Teil unseres Dienstes ausdrucken, kopieren oder herunterladen und damit gegen
        diese Geschäftsbedingungen verstoßen, erlischt Ihr Recht zur Nutzung unseres Dienstes
        unverzüglich und Sie müssen nach unserer Wahl alle Kopien der von Ihnen erstellten
        Materialien zurückgeben oder vernichten.
      </p>
      <p>Qmee ist eine in der EU und den USA eingetragene Marke von Kantar UK Ltd.</p>
    </section>
    <section>
      <h2>Unsere Haftung</h2>
      <p>
        Sofern wir diese Geschäftsbedingungen nicht einhalten, sind wir für von Ihnen erlittene
        Verluste oder Schäden verantwortlich, die eine vorhersehbare Folge davon sind, dass wir
        gegen diesen Vertrag verstoßen oder dass wir es unterlassen, angemessene Sorgfalt und
        Fachkenntnis anzuwenden. Wir sind jedoch für keine Verluste oder Schäden verantwortlich, die
        nicht vorhersehbar sind. Ein Verlust oder Schaden ist vorhersehbar, wenn es entweder
        offensichtlich ist, dass er eintreten wird, oder wenn sowohl wir als auch Sie zum Zeitpunkt
        des Vertragsabschlusses wussten, dass dieser eintreten könnte.
      </p>
      <p>
        Wir sind nicht haftbar oder verantwortlich für die Nichterbringung unserer Dienstleistung
        oder die Nichterfüllung oder verspätete Erfüllung einer unserer Verpflichtungen im Rahmen
        dieser Geschäftsbedingungen, die auf Gründe zurückzuführen sind, die außerhalb unserer
        zumutbaren Kontrolle liegen.
      </p>
      <p>
        Wir haften nicht für geschäftliche Verluste. Wir stellen den Dienst und die Software nur für
        den privaten Gebrauch zur Verfügung. Wenn Sie den Dienst oder die Software für kommerzielle,
        geschäftliche oder Wiederverkaufszwecke nutzen, haften wir Ihnen gegenüber nicht für
        entgangenen Gewinn, Geschäftsverluste, Geschäftsunterbrechungen oder den Verlust von
        Geschäftsmöglichkeiten.
      </p>
      <p>
        Nichts in diesen Geschäftsbedingungen schränkt unsere Haftung für Tod oder Personenschaden
        aufgrund unserer Fahrlässigkeit, unsere Haftung für arglistige Täuschung oder
        Falschdarstellungen in Bezug auf einen wesentlichen Sachverhalt sowie jede anderweitige
        Haftung ein, die nach geltendem Recht nicht ausgeschlossen oder beschränkt werden kann.
      </p>
      <p>
        Bei der Bereitstellung unseres Dienstes bieten wir Links zu den Websites Dritter an. Wir
        übernehmen keine Verantwortung für die Inhalte der Websites Dritter, zu denen ein Link
        besteht. Diese Links sollten nicht als Billigung dieser verlinkten Websites unsererseits
        verstanden werden. Wir haften nicht für Verluste oder Schäden, die durch Ihre Nutzung dieser
        Websites entstehen.
      </p>
    </section>
    <section>
      <h2>Missbrauch des Kontos</h2>
      <p>
        Unser Dienst soll normales Surfverhalten belohnen und Sie sollten nicht auf ein gesponsertes
        Ergebnis klicken, wenn Sie kein wirkliches Interesse an diesem gesponserten Ergebnis haben
        oder Umfragen unrichtig ausfüllen. Wenn wir der Meinung sind (oder unsere Algorithmen darauf
        hindeuten), dass Sie unseren Dienst missbrauchen, einschließlich, aber nicht beschränkt auf
        das Anklicken gesponserter Ergebnisse, an denen Sie kein wirkliches Interesse haben, das
        Anklicken eines gesponserten Ergebnisses bei mehreren Gelegenheiten oder das Ausfüllen von
        Umfragen unter Verwendung unrichtiger oder betrügerischer Informationen, sind wir
        berechtigt, nach unserem alleinigen Ermessen die Höhe der an Sie geleisteten Zahlungen zu
        reduzieren oder Zahlungen an Sie gänzlich einzustellen.
      </p>
      <p>
        Sie dürfen unseren Dienst nicht missbrauchen, indem Sie wissentlich Viren, Trojaner, Würmer,
        Logikbomben oder anderes böswilliges oder technologisch schädliches Material einführen.
      </p>
      <p>
        Sie dürfen nicht versuchen, sich unbefugten Zugang zu unserem Dienst (einschließlich unserer
        Website), dem Server, auf dem unsere Website gespeichert ist, oder einem mit unserem Dienst
        verbundenen Server, Computer oder einer Datenbank zu verschaffen. Sie dürfen unseren Dienst
        nicht durch eine Denial-of-Service-Attacke oder eine Distributed-Denial-of-Service-Attacke
        angreifen.
      </p>
      <p>
        Durch einen Verstoß gegen diese Bestimmung begehen Sie möglicherweise eine Straftat gemäß
        dem Computer Misuse Act 1990. Wir werden einen solchen Verstoß den zuständigen
        Strafverfolgungsbehörden melden und mit diesen Behörden kooperieren, indem wir Ihre
        Identität preisgeben. Im Falle eines Verstoßes erlischt Ihr Recht zur Nutzung unseres
        Dienstes (einschließlich unserer Website) unverzüglich.
      </p>
    </section>
    <section>
      <h2>Vertrauen in veröffentlichte Informationen</h2>
      <p>
        Kommentare und andere Materialien, die auf unserer Website veröffentlicht oder anderweitig
        durch unseren Dienst bereitgestellt werden, sind nicht als Ratschläge zu verstehen, auf die
        Sie sich verlassen sollten. Wir lehnen daher jede Haftung und Verantwortung ab, die sich
        daraus ergibt, dass Sie oder andere Personen, die über die Materialien informiert werden,
        sich auf die Materialien verlassen.
      </p>
    </section>
    <section>
      <h2>Gerichtsbarkeit und geltendes Recht</h2>
      <p>
        Die ausschließliche Zuständigkeit für alle Ansprüche, die sich aus dem Besuch unserer
        Website oder der Nutzung unseres Dienstes ergeben oder damit in Zusammenhang stehen, liegt
        bei den englischen Gerichten. Wir behalten uns jedoch das Recht vor, wegen eines Verstoßes
        gegen diese Geschäftsbedingungen in Ihrem Wohnsitzland oder in einem anderen relevanten Land
        Verfahren gegen Sie anzustrengen.
      </p>
      <p>
        Diese Nutzungsbedingungen und alle Streitigkeiten oder Ansprüche, die sich aus oder in
        Zusammenhang damit oder ihrem Gegenstand oder ihrer Entstehung ergeben (einschließlich
        außervertraglicher Streitigkeiten oder Ansprüche), unterliegen dem Recht von England und
        Wales und werden nach diesem ausgelegt. Sofern Sie jedoch in Nordirland ansässig sind,
        können Sie auch in Nordirland Klage erheben. Sofern Sie in Schottland ansässig sind, können
        Sie auch in Schottland Klage erheben.
      </p>
      <p>
        Wenn Sie Ihren Wohnsitz in den USA haben, unterliegt dieser Vertrag den Gesetzen des Staates
        New York und wird nach diesen ausgelegt, ohne dass die Grundsätze des Kollisionsrechts zur
        Anwendung kommen. Sie erklären sich damit einverstanden, dass jeder Fall, der sich auf eine
        Streitigkeit im Rahmen dieses Vertrages bezieht, zunächst von einem Schlichter in einem
        endgültigen, verbindlichen und unanfechtbaren Schiedsverfahren in New York, NY, gemäß den
        Regeln der American Arbitration Association entschieden wird. Die Kosten eines solchen
        Schiedsgerichtsverfahrens werden von den Parteien zu gleichen Teilen getragen. Falls der
        Schlichter zu dem Ergebnis kommt, dass die Schiedsgerichtsgebühren für Sie eine Härte
        darstellen würden, kann der Schlichter zuerkennen, dass Qmee 100 % der
        Schiedsgerichtsgebühren übernimmt (ohne Ihre Anwaltskosten, die von Ihnen zu tragen sind).
        Sie können auch telefonisch an dem Schiedsverfahren teilnehmen, wenn Sie nicht nach New York
        reisen können. Sie erklären sich damit einverstanden, jeden Fall einzeln und nicht als
        Mitglied einer Gruppe oder im Rahmen einer Sammelklage vorzubringen. SIE NEHMEN ZUR
        KENNTNIS, DASS SIE, ABGESEHEN VON DEN IN DIESEM ABSCHNITT DARGELEGTEN VERPFLICHTUNGEN, DAS
        RECHT AUF EIN VERFAHREN VOR EINEM GESCHWORENENGERICHT HÄTTEN UND SIE HIERMIT AUF DIESES
        RECHT VERZICHTEN. Ein Schiedsspruch kann von jedem zuständigen Gericht vollstreckt werden.
        Ungeachtet gegenteiliger Bestimmungen in diesem Vertrag erklären Sie sich damit
        einverstanden, dass Qmee eine Klage in Bezug auf seine geistigen Eigentumsrechte,
        einschließlich einer Unterlassungsverfügung im Zusammenhang mit diesen Rechten, bei jedem
        zuständigen Gericht einreichen kann, ohne den hierin vorgesehenen Schlichtungsmechanismus zu
        nutzen. Sie erkennen an und erklären sich damit einverstanden, dass die
        Gewährleistungsausschlüsse sowie die Haftungs- und Rechtsmittelbeschränkungen in diesem
        Vertrag wesentliche Bestimmungen des Vertrages sind und dass diese bei der Entscheidung von
        Qmee zur Bereitstellung des Dienstes berücksichtigt wurden. Sie dürfen keine Ihrer Rechte,
        Pflichten oder Vorrechte ohne die vorherige, schriftliche Zustimmung von Qmee abtreten.
        Dieser Vertrag und alle von Qmee veröffentlichten Betriebsvorschriften stellen die gesamte
        Vereinbarung der Parteien in Bezug auf den Vertragsgegenstand dar und ersetzen alle früheren
        oder zeitgleichen mündlichen oder schriftlichen Mitteilungen und Vorschläge zwischen den
        Parteien in Bezug auf den Vertragsgegenstand.
      </p>
    </section>
    <section>
      <h2>Alternative Streitbeilegung</h2>
      <p>
        Bei der alternativen Streitbeilegung handelt es sich um ein Verfahren, bei dem eine
        unabhängige Stelle den Sachverhalt einer Streitigkeit prüft und versucht, diese beizulegen,
        ohne dass Sie vor Gericht gehen müssen. Wenn Sie mit der Art und Weise, wie wir eine
        Beschwerde gehandhabt haben, nicht zufrieden sind, können Sie Streitigkeiten zur
        Online-Streitbeilegung an die Plattform zur Online-Streitbeilegung der Europäischen
        Kommission unter folgender Adresse übermitteln:{' '}
        <A href="https://ec.europa.eu/consumers/odr/" target="_blank">
          https://ec.europa.eu/consumers/odr/
        </A>
        .
      </p>
    </section>
    <section>
      <h2>Ihr Anliegen</h2>
      <p>
        Bei Fragen oder Beschwerden im Hinblick auf unsere Website, unsere Dienste, unsere Software
        oder Ihr Nutzerkonto wenden Sie sich bitte an{' '}
        <A href="mailto:support@qmee.com">support@qmee.com</A>. Unser Dienst zeigt einige Inhalte
        an, die Dritten gehören und von diesen zur Verfügung gestellt werden (gesponserte
        Suchmeldungen, Umfragen). Für diese Inhalte ist ausschließlich die betreffende Partei
        verantwortlich. Wir können Inhalte auf ihre Rechtmäßigkeit und die Einhaltung unserer
        Richtlinien überprüfen und Inhalte entfernen oder deren Anzeige verweigern, von denen wir
        annehmen, dass sie nicht konform sind. Wir überprüfen Inhalte jedoch nicht automatisch.
        Gehen Sie deshalb bitte nicht davon aus, dass wir dies tun. Sollten Sie Bedenken bezüglich
        der Inhalte haben, die im Rahmen unseres Dienstes angezeigt werden, wenden Sie sich bitte an{' '}
        <A href="mailto:support@qmee.com">support@qmee.com</A>.
      </p>
    </section>
    <p>Vielen Dank für Ihren Besuch unserer Website.</p>
    <p>
      <em>Letzte Aktualisierung: Februar 2026</em>
    </p>
  </>
);
